module.exports = __webpack_public_path__ + "img/zd-up-2.e5b64627.svg";